import WatchDashboard from '@/components/watch/WatchDashboard'

export default [
	{
		path: 'dashboard',
		name: 'WatchDashboard',
		component: WatchDashboard,
		props: true
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/watch/dashboard.js